import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import Styles from '../stripboard.module.scss';

export type DayBreakStripProps = {
  title: string;
};

export const UnscheduledHeader: React.FC<DayBreakStripProps> = observer(({ title }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: 'unscheduled-strips-header',
    data: {
      type: 'row',
    },
    disabled: true,
    animateLayoutChanges: () => true,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className={Styles.stickyStrip}
      style={style}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <div className={Styles.stickyStripContent}>
        <h3 className={Styles['day-name']}>{title}</h3>
      </div>
    </div>
  );
});
